module.exports = window.tcesdk;